module.exports = __webpack_public_path__ + "static/img/bear.b4178183.png";